import { createSelector } from '@reduxjs/toolkit';

import { PaymentProviders } from '@/enums';
import { getDefaultBidderCreditCard } from '@/redux/modules/account/payments/creditCard/creditCard/creditCard.selectors';

import {
    getBidderMobileVerified,
    getDefaultAddress,
    getDefaultAddressIsVerified,
    isUserAtLeastPartiallyRegistered,
} from '../user.selectors';

// user selectors can get very, very complex.
// Because of that, circular dependencies are going to be common.
// To avoid that, this file should contain selectors that pull from multiple slices.
// When it's all minified it would run fine, since everything's in one file,
// but test runs exploderate. 💥

const getIsAccountDetailsComplete = createSelector(
    [
        getDefaultAddress,
        getDefaultAddressIsVerified,
        (state) => getDefaultBidderCreditCard(state, PaymentProviders.Payrix),
        getBidderMobileVerified,
    ],
    (defaultAddress, addressVerified, defaultCreditCard, mobileVerified) =>
        Boolean(defaultAddress?.firstName) &&
        Boolean(defaultAddress?.lastName) &&
        Boolean(defaultAddress?.address1) &&
        addressVerified &&
        Boolean(defaultCreditCard?.id) &&
        mobileVerified
);

export const getIsProfileFullyCompleted = createSelector(
    [isUserAtLeastPartiallyRegistered, getIsAccountDetailsComplete],
    (userPartiallyRegistered, accountDetailsComplete) => userPartiallyRegistered && accountDetailsComplete
);

export const getShouldShowCompleteAccountBanner = createSelector(
    [isUserAtLeastPartiallyRegistered, getIsAccountDetailsComplete],
    (userPartiallyRegistered, accountDetailsComplete) => userPartiallyRegistered && !accountDetailsComplete
);
